import { messages } from 'languages'
import keyMirror from 'pkeymirror'
import callAPI from 'utils/callAPI'
import { getCurrentLanguage, setHtmlLangAndDir, getBotimClientId, isPayBy } from 'utils'
import sha256 from 'sha256'
import { replace } from 'connected-react-router'
import { Toast } from 'antd-mobile'

// ------------------------------------
// Constants
// ------------------------------------
export const SITE_CONFIG = keyMirror({
  LANGUAGE_CHANGE: null,
  APPAUTHORIZE_REQUEST: null,
  APPAUTHORIZE_SUCCESS: null,
  GET_SALT_REQUEST: null,
  GET_SALT_SUCCESS: null,
  REMOVE_SALT: null,
  QUERY_NOTICE_REQUEST: null,
  QUERY_NOTICE_SUCCESS: null,
  SAVE_SALT_KEY: null,
  GET_CAPTCHA_REQUEST: null,
  GET_CAPTCHA_SUCCESS: null,
  QUERY_KYC_STATUS_REQUEST: null,
  QUERY_KYC_STATUS_SUCCESS: null,
  SENDSMS_REQUEST: null,
  SENDSMS_SUCCESS: null,
  OAUTH_BY_AUTHCODE_REQUEST: null,
  OAUTH_BY_AUTHCODE_SUCCESS: null,
  SEND_MESSAGE_REQUEST: null,
  SEND_MESSAGE_SUCCESS: null,
  CHECKISLOGIN_REQUEST: null,
  CHECKISLOGIN_SUCCESS: null,
  QUERY_AREACODE_REQUEST: null,
  QUERY_AREACODE_SUCCESS: null,
  QUERY_CONFIG_ITEM_REQUEST: null,
  QUERY_CONFIG_ITEM_SUCCESS: null,
  SET_TIPS_VISIBLE: null,
  VEIRFY_CODE_REQUEST: null,
  VEIRFY_CODE_SUCCESS: null,
  QUERY_PROMOTER_REQUEST: null,
  QUERY_PROMOTER_SUCCESS: null,
  SENDSMS_LIMIT_REQUEST: null,
  SENDSMS_LIMIT_SUCCESS: null
}, 'SITE_CONFIG')

// ------------------------------------
// Actions
// ------------------------------------
export function languageChange(lang = 'en') {
  const language = lang.split(/[-_]/)[0].toLowerCase()
  setHtmlLangAndDir(language)
  return (dispatch) => {
    dispatch({
      type    : SITE_CONFIG.LANGUAGE_CHANGE,
      payload : language
    })
  }
}

function showFailedToast() {
  // 登陆失败，浮层提示保持以阻断用户操作
  Toast.info('Sorry, The verification information is expired. Please try again later.', 0)
}

export function getVerifyToken() {
  return (dispatch) => {
    return new Promise((resolve) => {
      if (process.env.NODE_ENV === 'development') {
        // 测试用户：100000081917 971140252158413237 +971-585806138
        return resolve({
          codeVerifier: 'test',
          verifyToken: 'f68db19e06d7469b96520da933f81918'
        })
      }
      function onBridgeReady() {
        // Bridge方法注册成功
        console.log('ToPayJSBridge:start')
        try {
          // window.ToPayJSBridge.init 方法二次调用的时候会报错
          window.ToPayJSBridge.init(function(message, responseCallback) {})
        } catch (error) {
          console.log(error)
        }
        const random = Math.random().toString(16).slice(-8)
        window.ToPayJSBridge.invoke(
          'getVerifyToken',
          {
            codeChallenge: sha256(random),
            appDomain: window.location.hostname
          },
          function(data) {
            if (data) {
              const res = JSON.parse(data)
              if (res && res.verifyToken) {
                return resolve({
                  codeVerifier: random,
                  verifyToken: res.verifyToken
                })
              } else {
                showFailedToast()
              }
            } else {
              showFailedToast()
            }
          }
        )
      }
      console.log(typeof ToPayJSBridge)
      if (typeof ToPayJSBridge === 'undefined') {
        document.addEventListener('ToPayJSBridgeReady', onBridgeReady, false) // ToPayJSBridgeReady
      } else {
        onBridgeReady()
      }
    })
  }
}

var loginable = true // 并发的登录请求，只允许一次，避免多次请求导致前面的token失效
export function login() {
  if (!loginable) {
    return
  }
  return (dispatch) => {
    loginable = false
    if (!isPayBy()) {
      Toast.hide()
      // 新增了OPT登陆流程，PayBy webview中走自动登录，非PayBy webview走OTP登陆流程
      const url = `${window.location.pathname}${window.location.search}`
      return dispatch(replace(`/login?redirect_url=${encodeURIComponent(url)}`))
    }
    Toast.loading('', 0)
    return dispatch(getVerifyToken()).then((res) => {
      dispatch(
        callAPI({
          dispatch: dispatch,
          endpoint: 'cgs/h5app/auth/v2/verify',
          body: {
            verifyToken: res.verifyToken,
            codeVerifier: res.codeVerifier
          },
          method: 'POST',
          requestAction: SITE_CONFIG.APPAUTHORIZE_REQUEST,
          successAction: SITE_CONFIG.APPAUTHORIZE_SUCCESS,
          success: function(result) {
            console.log(result)
            Toast.hide()
            localStorage.setItem('user_id', result.userId)
            dispatch(replace(`${window.location.pathname}${window.location.search}`))
          },
          error: () => {
            showFailedToast()
          }
        })
      )
    })
  }
}

export function getSalt() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/common/getSalt',
        requestAction: SITE_CONFIG.GET_SALT_REQUEST,
        successAction: SITE_CONFIG.GET_SALT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getAppSalt(saltKey) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          saltKey
        },
        endpoint: 'cgs/common/getAppSalt',
        requestAction: SITE_CONFIG.GET_SALT_REQUEST,
        successAction: SITE_CONFIG.GET_SALT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

export function removeSalt() {
  return (dispatch) => {
    dispatch({
      type: SITE_CONFIG.REMOVE_SALT,
    })
  }
}

export function queryNotice(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/notice/pull',
        requestAction: SITE_CONFIG.QUERY_NOTICE_REQUEST,
        successAction: SITE_CONFIG.QUERY_NOTICE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getCaptcha() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/personal/getCaptcha',
        requestAction: SITE_CONFIG.GET_CAPTCHA_REQUEST,
        successAction: SITE_CONFIG.GET_CAPTCHA_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryKycStatus(callback) {
  return dispatch => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/personal/kyc/kycInfo',
        method: 'POST',
        requestAction: SITE_CONFIG.QUERY_KYC_STATUS_REQUEST,
        successAction: SITE_CONFIG.QUERY_KYC_STATUS_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback(result)
        }
      })
    )
  }
}

export function sendSms(data, callback) {
  // 发短信
  const token = sha256(Math.random().toString(16).slice(-8))
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/otps/mns/sendbytarget',
        body: {
          target: data.phone,
          token
        },
        method: 'POST',
        requestAction: SITE_CONFIG.SENDSMS_REQUEST,
        successAction: SITE_CONFIG.SENDSMS_SUCCESS,
        success: function(result) {
          dispatch({
            type: SITE_CONFIG.SENDSMS_SUCCESS,
            payload: {
              token
            }
          })
          typeof callback === 'function' && callback()
        }
      })
    )
  }
}

export function oauthByAuthCode(data, callback) {
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/personal/auth/followOA', // 非授权接口 关注公众号
        method: 'POST',
        body: {
          hostApp: 'botim-pay',
          redirectUri: 'botmpx://me.botim.open.authorizer/index.html',
          clientId: getBotimClientId(),
          ...data
        },
        requestAction: SITE_CONFIG.OAUTH_BY_AUTHCODE_REQUEST,
        successAction: SITE_CONFIG.OAUTH_BY_AUTHCODE_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback()
        }
      })
    )
  }
}

export function sendMessage(data) { // BOTIM公众号消息推送
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/official/account/sendmsg',
        method: 'POST',
        body: data,
        requestAction: SITE_CONFIG.SEND_MESSAGE_REQUEST,
        successAction: SITE_CONFIG.SEND_MESSAGE_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

export function checkIsLogin(callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/common/checkLogon',
        requestAction: SITE_CONFIG.CHECKISLOGIN_REQUEST,
        successAction: SITE_CONFIG.CHECKISLOGIN_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback()
        }
      })
    )
  }
}

export function queryAreaCode() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/cmsii/country/queryAreaCode',
        method: 'POST',
        body: {
          scene: 'LOGIN',
        },
        requestAction: SITE_CONFIG.QUERY_AREACODE_REQUEST,
        successAction: SITE_CONFIG.QUERY_AREACODE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryConfigItem(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/cmsii/v1/app/configurationItem',
        method: 'POST',
        body: data,
        requestAction: SITE_CONFIG.QUERY_CONFIG_ITEM_REQUEST,
        successAction: SITE_CONFIG.QUERY_CONFIG_ITEM_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

export function setTipsVisible(data) {
  return (dispatch) => {
    dispatch({
      type: SITE_CONFIG.SET_TIPS_VISIBLE,
      payload: data
    })
  }
}

export function verifyCode(data, callback) { // 提交邀请码
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/personal/kyc/v2/invitation-code',
        method: 'POST',
        body: {
          ...data,
          source: window.location.pathname
        },
        requestAction: SITE_CONFIG.VEIRFY_CODE_REQUEST,
        successAction: SITE_CONFIG.VEIRFY_CODE_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback(result)
        }
      })
    )
  }
}

export function queryPromoter(callback) {
  // 查询是否是推广员
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/merchant-promoter/v1/auth/promoter/query',
        method: 'POST',
        requestAction: SITE_CONFIG.QUERY_PROMOTER_REQUEST,
        successAction: SITE_CONFIG.QUERY_PROMOTER_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback(result.commandData)
        }
      })
    )
  }
}

export function sendSmsLimit(data, callback) {
  // 发短信 限制次数、限制IP
  const token = sha256(Math.random().toString(16).slice(-8))
  const { phone } = data
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/otps/v1/unauth/marketing/sendbytarget',
        body: {
          target: phone && phone.replace('-0', '-'),
          token
        },
        method: 'POST',
        requestAction: SITE_CONFIG.SENDSMS_LIMIT_REQUEST,
        successAction: SITE_CONFIG.SENDSMS_LIMIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: SITE_CONFIG.SENDSMS_LIMIT_SUCCESS,
            payload: {
              token
            }
          })
          typeof callback === 'function' && callback()
        }
      })
    )
  }
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
const ACTION_HANDLERS = {
  [SITE_CONFIG.LANGUAGE_CHANGE]: (state, action) =>
    Object.assign({}, state, { language: action.payload }),
  [SITE_CONFIG.APPAUTHORIZE_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.APPAUTHORIZE_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.REMOVE_SALT]: (state, action) =>
    Object.assign({}, state, { salt: undefined }),
  [SITE_CONFIG.SAVE_SALT_KEY]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_NOTICE_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_NOTICE_SUCCESS]: (state, action) =>
    Object.assign({}, state, { notices: action.payload.messages }),
  [SITE_CONFIG.GET_CAPTCHA_REQUEST]: (state, action) => state,
  [SITE_CONFIG.GET_CAPTCHA_SUCCESS]: (state, action) =>
    Object.assign({}, state, { captcha: action.payload }),
  [SITE_CONFIG.QUERY_KYC_STATUS_REQUEST]: (state, action) => state,
  [SITE_CONFIG.QUERY_KYC_STATUS_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.SENDSMS_REQUEST]: (state, action) => state,
  [SITE_CONFIG.SENDSMS_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.OAUTH_BY_AUTHCODE_REQUEST]: (state, action) => state,
  [SITE_CONFIG.OAUTH_BY_AUTHCODE_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.SEND_MESSAGE_REQUEST]: (state, action) => state,
  [SITE_CONFIG.SEND_MESSAGE_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.CHECKISLOGIN_REQUEST]: (state, action) => state,
  [SITE_CONFIG.CHECKISLOGIN_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_AREACODE_REQUEST]: (state, action) => state,
  [SITE_CONFIG.QUERY_AREACODE_SUCCESS]: (state, action) =>
    Object.assign({}, state, { areaCode: action.payload.list }),
  [SITE_CONFIG.QUERY_CONFIG_ITEM_REQUEST]: (state, action) => state,
  [SITE_CONFIG.QUERY_CONFIG_ITEM_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      configContent: action.payload.content
    }),
  [SITE_CONFIG.SET_TIPS_VISIBLE]: (state, action) =>
    Object.assign({}, state, { tipsVisible: action.payload }),
  [SITE_CONFIG.VEIRFY_CODE_REQUEST]: (state, action) => state,
  [SITE_CONFIG.VEIRFY_CODE_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_PROMOTER_REQUEST]: (state, action) => state,
  [SITE_CONFIG.QUERY_PROMOTER_SUCCESS]: (state, action) =>
    Object.assign({}, state, { promoterCommandData: action.payload.commandData || {} }),
  [SITE_CONFIG.SENDSMS_LIMIT_REQUEST]: (state, action) => state,
  [SITE_CONFIG.SENDSMS_LIMIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload)
}

// ------------------------------------
// Reducer and set default language
// ------------------------------------
const language = 'en' || getCurrentLanguage()
setHtmlLangAndDir(language)
const initialState = {
  language: 'en', // language,
  messages: messages,
  showHeader: true,
}

function reducer(state = initialState, action = {}) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default {
  id: 'siteConfig',
  reducerMap: {
    siteConfig: reducer,
  },
  // Actions to fire when this module is added/removed
  // initialActions: [],
  // finalActions: []
}
